import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b59e2cf"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "thank-you"
}
const _hoisted_2 = { class: "thank-you__text-wrapper section" }
const _hoisted_3 = { class: "thank-you__title h2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Article = _resolveComponent("Article")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_GenericImageLayout = _resolveComponent("GenericImageLayout")!
  const _component_ContentBlockList = _resolveComponent("ContentBlockList")!
  const _directive_editable = _resolveDirective("editable")!

  return (_ctx.pageContent)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createBlock(_component_GenericImageLayout, {
          "image-src": _ctx.pageContent.image.filename,
          "mobile-image": ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.pageContent.title), 1),
              (_ctx.isAreaSupported)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Article, _mergeProps(_ctx.cmsBlockToProps(_ctx.pageContent.virtualSurveyText), {
                      ref: "virtualSurveyText",
                      class: "thank-you__copy mt-6"
                    }), null, 16),
                    _createVNode(_component_Article, _mergeProps(_ctx.cmsBlockToProps(_ctx.pageContent.nextStepsForCoveredArea), { class: "thank-you__copy" }, { "variable-set": _ctx.contentVariables }), null, 16, ["variable-set"]),
                    _createVNode(_component_AppButton, {
                      ref: "virtualSurveyButton",
                      class: "thank-you__button",
                      href: _ctx.pageContent.virtualSurveyLink
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.pageContent.virtualSurveyButton), 1)
                      ], undefined, true),
                      _: 1
                    }, 8, ["href"]),
                    _createVNode(_component_Article, _mergeProps(_ctx.cmsBlockToProps(_ctx.pageContent.bookCallText), {
                      ref: "bookCallText",
                      class: "thank-you__copy mt-6"
                    }), null, 16),
                    _createVNode(_component_AppButton, {
                      ref: "bookCallLink",
                      class: "thank-you__button",
                      href: _ctx.pageContent.bookCallLink
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.pageContent.bookCallButton), 1)
                      ], undefined, true),
                      _: 1
                    }, 8, ["href"])
                  ], 64))
                : (_ctx.isFlatRoof)
                  ? (_openBlock(), _createBlock(_component_Article, _mergeProps({ key: 1 }, _ctx.cmsBlockToProps(_ctx.pageContent.nextStepsForFlatRoof), { class: "thank-you__copy" }, { "variable-set": _ctx.contentVariables }), null, 16, ["variable-set"]))
                  : (_openBlock(), _createBlock(_component_Article, _mergeProps({ key: 2 }, _ctx.cmsBlockToProps(_ctx.pageContent.nextStepsForOutsideArea), { class: "thank-you__copy mt-7" }, { "variable-set": _ctx.contentVariables }), null, 16, ["variable-set"]))
            ])
          ], undefined, true),
          _: 1
        }, 8, ["image-src"])), [
          [_directive_editable, _ctx.pageContent]
        ]),
        _createVNode(_component_ContentBlockList, {
          blocks: _ctx.pageContent.body
        }, null, 8, ["blocks"])
      ]))
    : _createCommentVNode("", true)
}